import api from './api';
import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';


export interface CorrespondenciaFilter {
  contrato: string;
  fornecedor: string;
}

export interface RelatorioStatusCorrespondencias {
  numeroContrato: string;
  fornecedor: string;
  codigo: number;
  assunto: string;
  dataEnvio: string;
  prazoResposta: number;
}

export const searchValues = (values: CorrespondenciaFilter) => {
  return api.post<RelatorioStatusCorrespondencias[]>('relatorios/correspondencia', values, {
    disableNotification: 'true',
  });
};



  
export const relatorioExportExcel = (values: CorrespondenciaFilter) => {

  let urlBase = window.location.origin;
  trackPromise(Axios.post(urlBase + `/api/relatorios/correspondencia/excel`, values,
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "Relatorio_de_Status_de_Correspondencia.xlsx");
      link.setAttribute('id', 'downloadRelatorio');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadRelatorio').outerHTML = '';
    }));
};
